export default "/_next/static/images/adsBg-0be8befe5e08ee9c9a406964291748b6.png";